var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseXCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM20.9752 8.53701C21.6622 7.85037 22.7759 7.85037 23.4629 8.53701C24.1497 9.22386 24.1497 10.3372 23.4629 11.0241L18.4876 16L23.4629 20.9759C23.9202 21.4175 24.1036 22.0715 23.9426 22.6864C23.7816 23.3014 23.3013 23.7817 22.6862 23.9426C22.0711 24.1036 21.417 23.9202 20.9752 23.463L16 18.4871L11.0248 23.463C10.583 23.9202 9.92894 24.1036 9.31384 23.9426C8.69874 23.7817 8.21838 23.3014 8.05738 22.6864C7.89638 22.0715 8.07979 21.4175 8.53713 20.9759L13.5124 16L8.53713 11.0241C8.07979 10.5825 7.89638 9.92851 8.05738 9.31355C8.21838 8.69859 8.69874 8.21833 9.31384 8.05737C9.92894 7.8964 10.583 8.07978 11.0248 8.53701L16 13.5129L20.9752 8.53701Z",
    fill: "currentcolor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseXCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/closeXCircle.91002ab850b1acb5deb7b31660bbb95c.svg";